import { React, useState, useEffect } from "react";
import { Eye, UserRound } from "lucide-react";
import { Heart } from "lucide-react";
import { ShoppingBag } from "lucide-react";
import { History } from "lucide-react";
import { MapPinHouse } from "lucide-react";
import { UserRoundPen } from "lucide-react";
import { Car } from "lucide-react";
import { LogOut } from "lucide-react";
import Footer from "../../homePage/components/footer/Footer";
import air_flow_sensor from "../../../../../assets/image/category/air_flow_sensor.jpeg";
import knock_sensor from "../../../../../assets/image/category/knock_sensor.jpeg";
import lambda_sensor from "../../../../../assets/image/category/lambda_sensor.jpeg";
import engine_oil from "../../../../../assets/image/category/engine_oil.jpeg";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getWebOrder } from "../../../../redux/reduxApi/website/OrdersReduxApi";
export default function Orders() {
  const dispatch = useDispatch();
  const [orderData, setOrderData] = useState({
    page: "1",
    size: "30",
  });
  const [dataOrder, setDataOrder] = useState([]);
  const getOrders = useSelector((state) => state.order.order);
  //  console.log('getOrders?????????????????',getOrders)
  useEffect(() => {
    setDataOrder(getOrders);
  }, [getOrders]);
  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const response = await dispatch(getWebOrder(orderData));
        console.log("this is dataOrder list after that ", dataOrder);
      } catch (error) {
        console.error("Error fetching dataOrder :", error);
      }
    };

    fetchOrders();
  }, [dispatch]);

  return (
    <>
      <div className="lg:py-[15px] md:py-[15px]">
        <h1 className="text-center text-blue-900 font-bold lg:text-[40px] md:text-3xl text-3xl mb-2">
          Orders
        </h1>
        <hr className="heading-seperator border-4 border-blue-900" />

        {/* Order Table */}
        <div className="w-full d-none d-sm-block ">
          <table
            className=" bg-gray-50 p  rounded-xl shadow-md "
            style={{ width: "100%" }}
          >
            <thead className="text-[18px] ">
              <tr>
                <th className="py-2 px-4 border-b">Order</th>
                <th className="py-2 px-4 border-b">Date</th>
                <th className="py-2 px-4 border-b">Total</th>
                <th className="py-2 px-4 border-b">Status</th>
                <th className="py-2 px-4 border-b">Actions</th>
              </tr>
            </thead>
            <tbody>
              {dataOrder &&
                dataOrder.slice().map((item, index) => (
                  <tr key={index}>
                    <td className="py-3 px-4 border-b">#{item.ROWID}</td>
                    <td className="py-3 px-4 border-b">
                      {new Date(item.CREATEDTIME).toLocaleString("en-US", {
                        hour: "numeric",
                        minute: "numeric",
                        hour12: true,
                      })}
                    </td>
                    <td className="py-3 px-4 border-b">${item.totalAmount}</td>
                    <td className="  border-b text-sm  m-10  ">
                      <div className="rounded-full text-center py-[9px] px-4  bg-orange-100 text-orange-800">
                        {item.status || "pending"}
                      </div>
                    </td>
                    <td className="py-3 px-4 border-b">
                      <Link to={`/account/view-order/${item.ROWID}`}>
                        <button className="bg-blue-700 text-white py-1 px-4 rounded">
                          View
                        </button>
                      </Link>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
        {/* for mobile view */}
        {dataOrder &&
          dataOrder.slice().map((item, index) => (
            <div
              className="rounded-lg border border-gray-500 p-2 px-3 d-block d-sm-none bg-white mb-2"
              key={index}
            >
              <table className="w-100 ">
                <tbody>
                  <tr className="border-b-2 border-gray-300 ">
                    <td className="w-50 font-bold py-1">#{item.ROWID}</td>
                    <td className="w-100 flex justify-end">
                      <Link to={`/account/view-order/${item.ROWID}`}>
                        <Eye size="25px" color="orange" />
                      </Link>
                    </td>
                  </tr>
                  <tr className="border-b-2 border-gray-300 ">
                    <th className="w-50 py-1">Order Date</th>
                    <td className=" py-1 flex justify-end">
                      {new Date(item.CREATEDTIME).toLocaleDateString()}
                    </td>
                  </tr>
                  <tr className="border-b-2 border-gray-300 ">
                    <th className="w-50 py-1 ">Status</th>
                    <td>
                      <div
                        className={`${item.status === "pending"
                          ? "bg-orange-100 py-[7px] px-4  w-35 ml-10 text-orange-800 rounded-full"
                          : ""
                          } my-1 flex justify-end`}
                      >
                        {item.status || "pending"}
                      </div>
                    </td>
                  </tr>
                  <tr className="">
                    <th className="w-50 py-1">Total</th>
                    <td className=" py-1 flex justify-end">
                      ${Number(item.totalAmount).toFixed(2)}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          ))}
        {/* for mobile view end */}
        {/* Order Table end here */}
      </div>
    </>
  );
}
